import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b9ba320"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  props: {
    content: null,
    theme: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["more-text", __props.theme])
  }, [
    _createElementVNode("a", {
      class: "close icon i-guanbi",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    }),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "html",
        innerHTML: __props.content
      }, null, 8, _hoisted_1)
    ])
  ], 2))
}
}

})